import { Box, Divider, Typography } from "@mui/joy";
import { FormProvider, useForm } from "react-hook-form";

import { CategoryConfiguration, Action } from "./components";
import useCreateCategory from "./hooks/useCreateCategory";
import newProductCategoryResolver from "../../../../libs/form-validations/new-product-category";
import Breadcrumb from "./components/Breadcrumb";

import { Alert } from "../../../../shared";

const INITIAL_VALUES = {
    Name: "",
    Description: "",
    DefaultUnitType: "",
    MeasurementTypes: null as any,
    IsActive: true,
    Tags: {} as Record<string, string>,
};

export default function Create() {
    const { handleCreateCategory, createCategorySvc } = useCreateCategory();

    const methods = useForm({
        resolver: newProductCategoryResolver,
        defaultValues: INITIAL_VALUES,
    });

    const onSubmit = methods.handleSubmit(handleCreateCategory);

    return (
        <Box flex={1}>
            <Breadcrumb />

            <Divider />
            <Box ml={3} mt={2} mb={3}>
                <Typography level={"title-sm"}>New Product Category</Typography>
                <Typography level={"body-sm"}>Enter the basic details for the new product category.</Typography>
            </Box>
            <Box component={"div"} ml={3} mt={2} width={700}>
                <FormProvider {...methods}>
                    <form onSubmit={onSubmit}>
                        <Box display={"flex"} gap={2} flexDirection={"column"}>
                            <CategoryConfiguration />
                            <Action api={createCategorySvc} />
                            <Alert
                                successMessage={createCategorySvc.isSuccess && "Product category created successfully!"}
                                sx={{ mt: 3 }}
                                errorMessage={
                                    createCategorySvc.isError && "Failed to create product category. Please try again."
                                }
                            />
                        </Box>
                    </form>
                </FormProvider>
            </Box>
        </Box>
    );
}
